export const EXTERNAL_LINKS = {
  BRAND_GUIDELINES: 'https://drive.google.com/file/d/1lluicHTVqbeWdD7j_BbJuyG6J65wwrf_/view',
}
